import React from 'react';
import { Zap } from 'lucide-react';

const GuvenBolumu = () => {
    return (
        <div className="mt-10 text-center bg-white dark:bg-bg-secondary rounded-3xl p-8 shadow-xl border border-border-light max-w-5xl mx-auto relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-orange-500 to-primary"></div>

            <div className="inline-flex items-center gap-2 px-6 py-2 bg-orange-100 text-orange-700 rounded-full mb-6 animate-pulse">
                <Zap size={18} fill="currentColor" />
                <span className="text-sm font-extrabold tracking-wide">1 AY ÜCRETSİZ DENEME</span>
            </div>

            <h3 className="text-3xl font-bold text-text-primary mb-4">
                Hemen Şantiyeye İnmeye Hazır Mısınız?
            </h3>
            <p className="text-text-secondary max-w-2xl mx-auto mb-8 text-lg">
                Kredi kartı bilgilerinizi girmeden, tüm özellikleri <strong>1 ay boyunca</strong> sınırsız test edin.
                Beğenmezseniz (ki beğeneceksiniz) hiçbir ücret ödemezsiniz.
            </p>

            <button className="bg-orange-600 text-white px-10 py-4 rounded-xl font-bold text-xl hover:bg-orange-700 hover:shadow-orange-500/30 transition-all shadow-xl transform hover:-translate-y-1">
                Ücretsiz Denemeyi Başlat
            </button>

            <div className="mt-8 flex flex-wrap justify-center gap-6 text-text-muted text-sm font-medium">
                <span className="flex items-center gap-1.5"><span className="text-green-500">✓</span> 256-bit SSL Güvenliği</span>
                <span className="flex items-center gap-1.5"><span className="text-green-500">✓</span> İyzico Güvencesi</span>
                <span className="flex items-center gap-1.5"><span className="text-green-500">✓</span> KVKK Uyumlu</span>
            </div>
        </div>
    );
};

export default GuvenBolumu;
